import HeroBG from "../../Components/Style/HeroBG"
import LiquidGlass from "../../Components/Style/LiquidGlass"
import ContainerSignInPhone from "./Components/ContainerSignInPhone"
export default function SignInPhone() {
  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark p-4">
      <div className="absolute inset-0 z-0 transition-none">
        <HeroBG />
      </div>
      <LiquidGlass tag="div" rounded="3xl" className="rounded-3xl max-w-sm w-full flex z-10" childrenClassName="w-full">
        <ContainerSignInPhone text="ورود به حساب کاربری"/>
      </LiquidGlass>
      <span className="hidden absolute w-full h-[1px] bottom-16 bg-zi-gradient-divider"></span>
    </div>
  )
}
